import { render } from "./ArticlePhotoForm.vue?vue&type=template&id=afff7630"
import script from "./ArticlePhotoForm.vue?vue&type=script&lang=js"
export * from "./ArticlePhotoForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/pg.vermont.eu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__